import { render, staticRenderFns } from "./all-department.vue?vue&type=template&id=4a461c8e&scoped=true"
import script from "./all-department.vue?vue&type=script&lang=js"
export * from "./all-department.vue?vue&type=script&lang=js"
import style0 from "./all-department.vue?vue&type=style&index=0&id=4a461c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a461c8e",
  null
  
)

export default component.exports